import React from "react";
import { FiExternalLink } from "react-icons/fi";
import "./Projects.css";

export default function Projects() {
  return (
    <section id="projects" className="projects">
      <h3>Projects</h3>
      <div className="project-grid">
        {/* ✅ Coded Projects */}
        <div className="project-card">
          <h4>To-do App</h4>
          <p>
            Simple and responsive task manager built with React. Includes edit,
            delete, undo, and calendar features.
          </p>
          <a
            href="https://to-do-delta-red.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Live <FiExternalLink />
          </a>
        </div>

        <div className="project-card">
          <h4>Weather Dashboard</h4>
          <p>
            Real-time weather app using the Tomorrow.io API. Includes location
            search, hourly forecast, and dark mode.
          </p>
          <a
            href="https://weatherapp-79s8.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Live <FiExternalLink />
          </a>
        </div>

        <div className="project-card">
          <h4>Drone Delivery System</h4>
          <p>
            Final-year project demo for managing drone-based deliveries. Built
            with React and deployed on Vercel.
          </p>
          <a
            href="https://drone-omega.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Live <FiExternalLink />
          </a>
        </div>

        {/* ✅ Figma Designs */}
        <div className="project-card">
          <h4>DRONEX UI Design</h4>
          <p>
            A Drone Based Delivery UI Design.
          </p>
          <a
            href="https://www.figma.com/design/p2eklAIWMt6pDNA23EwOB8/DRONEX?m=auto&t=3yX0vtRhj4GMn4ud-6"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Figma <FiExternalLink />
          </a>
        </div>

        <div className="project-card">
          <h4>Nectar E-commerce UI</h4>
          <p>
            High-fidelity e-commerce interface with home, product, and checkout
            screens. Created with modern Figma components and layout grids.
          </p>
          <a
            href="https://www.figma.com/design/PMDA9SLYS9c9XjybS9e4Qu/nectar?m=auto&t=hzm3TDt3qTOvMuuj-6"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Figma <FiExternalLink />
          </a>
        </div>

        <div className="project-card">
          <h4>BIZBUZZ E-commerce App UI</h4>
          <p>
            E-commerce mobile design for a finance/product brand. Includes
            catalog, cart, and payment screens with focus on mobile UX.
          </p>
          <a
            href="https://www.figma.com/design/LB6ZV9heF6lBFqkjyAyKa8/BIZBUZZ?m=auto&t=3yX0vtRhj4GMn4ud-6"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Figma <FiExternalLink />
          </a>
        </div>
      </div>
    </section>
  );
}
